exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: table-cell; }\n\n.sortable {\n  cursor: pointer; }\n  .sortable .hover-feedback {\n    display: none; }\n  .sortable:hover .hover-feedback {\n    display: inline; }\n\n.oi-caret-bottom, .oi-caret-top {\n  font-size: 8px;\n  margin-left: 3px;\n  position: relative;\n  top: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/table-header/table-header-cell/table-header-cell.component.scss
// module id = ../../../../../src/app/shared/components/table-header/table-header-cell/table-header-cell.component.scss
// module chunks = 12